import React, { useContext, useEffect, useState } from "react";

import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";

import { ContextSolicitacoes } from "../../../services/solicitacoes";

import { getDocumentos } from "../../../services/meuImovel";

import { ReactComponent as Checkbox } from "../../../assets/novosicones/check_box_black_18dp.svg";

import { ReactComponent as CheckboxBlank } from "../../../assets/novosicones/Solicitacoes/entendiConcordoBlank.svg";

import {
  Text,
  EntendiContainer,
  InputContainer,
  CustomizedInput,
} from "./styles";
import { ContextSindico } from "../../../services/sindico";

const EntendiConcordo = ({
  setEntendiConcordo,
  entendiConcordo,
  imovel,
  loadingTentativaAgendamento,
  isSindico,
  savingChanges,
}) => {
  const { tema } = useContext(
    isSindico ? ContextSindico : ContextoListaApartamentos
  );

  const { listaDeImoveis, imovelSolicitacao } = useContext(
    isSindico ? ContextSindico : ContextSolicitacoes
  );

  const [manualUso, setManualUso] = useState("");

  const handleEntendi = () => {
    if (!loadingTentativaAgendamento)
      setEntendiConcordo((prevState) => !prevState);
  };

  const loadManualDeUso = async () => {
    let temp = listaDeImoveis.find(
      (imov) => imov.nome === imovelSolicitacao || imov.assetId === imovel
    );

    if (temp) {
      let documents = await getDocumentos(
        temp.contratos[0].numeroContrato,
        temp.empreendimento.empreendimentoIdSalesForce
      );

      setManualUso(
        documents.find((doc) => doc.TipoDocumento === "Manual do proprietário")
      );
    }
  };

  useEffect(() => {
    (async function () {
      if (listaDeImoveis?.length && !isSindico) await loadManualDeUso();
    })();
  }, []);

  return (
    <EntendiContainer>
      <Text>Prezado(a) Cliente,</Text>
      <Text>
        Esse tipo de acionamento possui variações de garantias. Antes de
        finalizar a solicitação, é importante consultar o{" "}
        {manualUso ? (
          <a
            href={manualUso?.Url}
            target="_blank"
            rel="noreferrer"
            style={{ color: tema.primaryColor, fontWeight: "bold" }}
          >
            Manual de Uso e Manutenção do Proprietário
          </a>
        ) : (
          `Manual de Uso e Manutenção do Proprietário`
        )}{" "}
        para verificar a vigência do prazo de garantia e o programa de
        manutenção preventiva, do(s) item(ns) pontuado(s).
      </Text>
      <Text>
        A construtora esclarece, que caso seja evidenciado a improcedência da
        assistência técnica aberta, uma taxa em relação a visita do técnico
        poderá ser cobrada.
      </Text>
      <InputContainer
        onClick={
          !savingChanges && !loadingTentativaAgendamento && handleEntendi
        }
      >
        <CustomizedInput>
          {!entendiConcordo && <CheckboxBlank fill={"#848484"} />}
          {entendiConcordo && <Checkbox fill={tema.primaryColor} />}
        </CustomizedInput>
        <Text
          color={entendiConcordo ? tema.primaryColor : "#4d4d4d"}
          style={{ fontWeight: "bold" }}
        >
          Entendi e concordo
        </Text>
      </InputContainer>
    </EntendiContainer>
  );
};

export default EntendiConcordo;
